var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjuryArmLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 140,
    viewBox: "0 0 30 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.286 1c1.452.749 2.735 1.36 3.868 1.923l.512.257c7.11 3.59 7.939 5.627 7.939 30.32 0 29.05 3.01 42.646 4.664 54.2 1.102 7.704 1.495 24.799 1.177 51.284l-10.62-.144v-14.697C11.29 106.415 8.08 94.267 8.2 87.701 8.2 69.546 5.8 55.87 1 46.673l.11.21-.11.275.07-.348-.07-.137z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryArmLeft);
export default __webpack_public_path__ + "static/media/injury-arm-left.f3d43b96ac748c64a5dd20f7556343ec.svg";
export { ForwardRef as ReactComponent };